var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomFontActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30502",
    "data-name": "Group 30502",
    transform: "translate(10709 -17341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30485",
    "data-name": "Group 30485"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14180",
    "data-name": "Rectangle 14180",
    width: 32,
    height: 32,
    transform: "translate(-10709 17341)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30610",
    "data-name": "Group 30610",
    transform: "translate(-10836.005 17022.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50104",
    "data-name": "Path 50104",
    d: "M146.076,341.071h-4.457a1.424,1.424,0,1,1,0-2.846h.767v-6.232h-1.46v.568a1.463,1.463,0,0,1-2.925,0v-1.992a1.445,1.445,0,0,1,1.462-1.424h8.768a1.445,1.445,0,0,1,1.462,1.424v1.992a1.462,1.462,0,0,1-2.923,0v-.568h-1.46v6.232h.765a1.424,1.424,0,1,1,0,2.846Zm-4.457-1.945a.522.522,0,1,0,0,1.044h4.457a.522.522,0,1,0,0-1.044h-1.229a.457.457,0,0,1-.462-.451v-7.133a.456.456,0,0,1,.462-.45h2.386a.457.457,0,0,1,.463.45v1.019a.536.536,0,0,0,1.072,0v-1.992a.53.53,0,0,0-.537-.522h-8.768a.53.53,0,0,0-.537.522v1.992a.537.537,0,0,0,1.073,0v-1.019a.456.456,0,0,1,.462-.45h2.387a.456.456,0,0,1,.462.45v7.133a.457.457,0,0,1-.462.451Z",
    transform: "translate(-0.849 -0.722)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50105",
    "data-name": "Path 50105",
    d: "M135.61,341.227a.4.4,0,0,1-.343-.446V329.368a.355.355,0,1,1,.686,0v11.413A.4.4,0,0,1,135.61,341.227Z",
    transform: "translate(-0.344 -0.688)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50106",
    "data-name": "Path 50106",
    d: "M150.489,341.227a.4.4,0,0,1-.343-.446V329.368a.355.355,0,1,1,.686,0v11.413A.4.4,0,0,1,150.489,341.227Z",
    transform: "translate(0.243 -0.688)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50107",
    "data-name": "Path 50107",
    d: "M149.394,327.339H137.981a.355.355,0,1,1,0-.686h11.413a.355.355,0,1,1,0,.686Z",
    transform: "translate(-0.688 -0.344)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50108",
    "data-name": "Path 50108",
    d: "M149.394,342.219H137.981a.355.355,0,1,1,0-.686h11.413a.355.355,0,1,1,0,.686Z",
    transform: "translate(-0.688 0.243)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50109",
    "data-name": "Path 50109",
    d: "M135.265,328.919a2.266,2.266,0,1,1,2.266-2.266A2.269,2.269,0,0,1,135.265,328.919Zm0-3.847a1.58,1.58,0,1,0,1.58,1.58A1.582,1.582,0,0,0,135.265,325.072Z",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50110",
    "data-name": "Path 50110",
    d: "M135.265,343.8a2.267,2.267,0,1,1,2.266-2.267A2.27,2.27,0,0,1,135.265,343.8Zm0-3.847a1.581,1.581,0,1,0,1.58,1.58A1.582,1.582,0,0,0,135.265,339.951Z",
    transform: "translate(0 0.587)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50111",
    "data-name": "Path 50111",
    d: "M150.144,328.919a2.266,2.266,0,1,1,2.267-2.266A2.269,2.269,0,0,1,150.144,328.919Zm0-3.847a1.58,1.58,0,1,0,1.581,1.58A1.582,1.582,0,0,0,150.144,325.072Z",
    transform: "translate(0.587)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50112",
    "data-name": "Path 50112",
    d: "M150.144,343.8a2.267,2.267,0,1,1,2.267-2.267A2.27,2.27,0,0,1,150.144,343.8Zm0-3.847a1.581,1.581,0,1,0,1.581,1.58A1.582,1.582,0,0,0,150.144,339.951Z",
    transform: "translate(0.587 0.587)",
    stroke: "#000",
    strokeWidth: 0.1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFontActive);
export default __webpack_public_path__ + "static/media/custom_font_active.1d4aff77.svg";
export { ForwardRef as ReactComponent };